module.exports = __webpack_public_path__ + "img/kl.a6ef3156.png";